export enum SelfGuidedAccessMethod {
  CODEBOX = 'CodeBox lockbox',
  COMBO_LOCKBOX = 'Combination lockbox',
  INSTRUCTIONS = 'Written instructions',
  SMART_LOCK = 'Smart lock link',
}
